import { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';
import { change } from 'redux-form';

import { INQUIRY_TEMPLATE_EDITOR_FORM_NAME } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/constants';
import { UiComponentConfig } from 'lib/interfaces/ui-components';

const useSubmitStyleVariant = (
  component: UiComponentConfig,
  componentBasePath: string,
  styleVariantIndex: number,
  namespace = 'base',
) => {
  const path = `steps.${componentBasePath}.style-variants.${styleVariantIndex}`;
  const dispatch = useDispatch();

  const submitStyleVariantField = useCallback(
    (field: string | null, values: unknown) => {
      const hasStyleVariant = component?.['style-variants']?.find(
        (variant) => variant.namespace === namespace,
      );
      batch(() => {
        if (hasStyleVariant == null) {
          dispatch(change(INQUIRY_TEMPLATE_EDITOR_FORM_NAME, `${path}.namespace`, namespace));
        }

        if (field) {
          dispatch(change(INQUIRY_TEMPLATE_EDITOR_FORM_NAME, `${path}.${field}`, values));
        } else {
          // If no field is provided, we assume that the entire style variant is being updated
          // This is primarily needed in the codeMirror editor for the stepper component where
          // users can directly edit the entire style variant.
          dispatch(change(INQUIRY_TEMPLATE_EDITOR_FORM_NAME, `${path}`, values));
        }
      });
    },
    [component, dispatch, namespace, path],
  );

  return { submitStyle: submitStyleVariantField, path };
};

export default useSubmitStyleVariant;
